import {SvgIconProps} from "@mui/material";
import React, {ReactNode} from "react";
import AbstractIcon from "../AbstractIcon";


class ActiveResourceTracks extends AbstractIcon {

    public renderDraw(props: SvgIconProps): ReactNode {
        return (
            <g>
                <path d="m 4,5 v 5 H 5 V 5 Z"/>
                <path d="M 6,6 V 9 H 7 V 6 Z"/>
                <path d="m 8,3 v 9 H 9 V 3 Z"/>
                <path d="m 10,4 v 7 h 1 V 4 Z"/>
                <path d="m 12,2 v 11 h 1 V 2 Z"/>
                <path d="m 14,5 v 5 h 1 V 5 Z"/>
                <path d="m 16,6 v 3 h 1 V 6 Z"/>
                <path d="m 18,4 v 7 h 1 V 4 Z"/>
                <path d="M 2,6 V 9 H 3 V 6 Z"/>
                <path d="m 20,6 v 3 h 1 V 6 Z"/>
                <path d="m 22,7 v 1 h 1 V 7 Z"/>
                <g transform="rotate(90,11.999999,18)">
                    <path d="m 9,15.099609 v 1 0.400391 4.400391 1 h 1 V 21 h 1 v 0.900391 h 1 V 21 h 1 v 0.900391 h 1 V 21 h 0.05273 A 3,3 0 0 1 13.826172,20 H 10 v -3 h 5 v 0.464844 a 3,3 0 0 1 1,-0.501953 v -0.863282 -1 H 15 V 16 H 14 V 15.099609 H 13 V 16 H 12 V 15.099609 H 11 V 16 h -1 v -0.900391 z" transform="rotate(-90,12.499999,18.5)"/>
                </g>
                <path d="m 16,22 c -0.979201,-0.101655 -1.816283,-0.856051 -2.03539,-1.834348 -0.05931,-0.264879 -0.05931,-0.739477 0,-1.004345 0.221829,-0.990457 1.025878,-1.711033 2.040886,-1.829021 0.276521,-0.03214 0.610344,-0.0063 0.849638,0.06581 0.06614,0.01985 0.134724,0.03622 0.152455,0.03622 0.02638,0 0.03342,-0.463801 0.03897,-2.553722 l 0.0068,-2.553728 0.06649,-0.195967 c 0.183756,-0.541419 0.613852,-0.927748 1.170617,-1.051466 0.157622,-0.03503 0.317991,-0.03981 1.126823,-0.03361 l 0.94307,0.0073 0.134724,0.06391 c 0.290717,0.137933 0.452856,0.391308 0.452856,0.707708 0,0.306764 -0.154277,0.556074 -0.436017,0.704629 l -0.127055,0.06701 -0.887986,0.0079 -0.887986,0.0079 v 3.585247 c 0,2.390798 -0.0087,3.649111 -0.02611,3.776889 -0.112478,0.829256 -0.640615,1.520946 -1.414164,1.852096 -0.318619,0.136355 -0.81642,0.210407 -1.168725,0.17383 z"/>
            </g>
        );
    }

}


export default ActiveResourceTracks;